/**
 * Template Analytics Hooks
 *
 * React Query hooks for marketplace analytics.
 */
import { useQuery } from '@tanstack/react-query';
import { templateAnalyticsService } from '../services/template-analytics';

export const analyticsKeys = {
  all: ['templateAnalytics'] as const,
  template: (id: string, days: number) =>
    [...analyticsKeys.all, 'template', id, days] as const,
  author: (days: number) => [...analyticsKeys.all, 'author', days] as const,
};

/**
 * Hook to fetch analytics for a specific template.
 */
export function useTemplateAnalytics(templateId: string | undefined, days: number = 30) {
  return useQuery({
    queryKey: analyticsKeys.template(templateId!, days),
    queryFn: () => templateAnalyticsService.getTemplateAnalytics(templateId!, days),
    enabled: !!templateId,
  });
}

/**
 * Hook to fetch author-level analytics for the current user.
 */
export function useAuthorAnalytics(days: number = 30) {
  return useQuery({
    queryKey: analyticsKeys.author(days),
    queryFn: () => templateAnalyticsService.getAuthorAnalytics(days),
  });
}
